var _path, _mask, _g, _mask2, _g2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M23.384 26.15c.673 0 1.22-.6 1.22-1.34v-5.106c0-.9-.665-1.631-1.484-1.631H18.48c-.673 0-1.22.6-1.22 1.341 0 .74.547 1.341 1.22 1.341h1.96l-2.87 3.159-1.238-1.362c-.477-.524-1.249-.524-1.725 0L10.89 26.64c-.476.524-.476 1.373 0 1.897.238.262.55.393.863.393.312 0 .623-.13.862-.393l2.853-3.138 1.238 1.361c.457.503 1.267.503 1.725 0l3.734-4.108v2.158c0 .74.546 1.341 1.22 1.341",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "oq3iuu0dia",
    width: 45,
    height: 50,
    x: 5,
    y: 6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.454 6H50v50H5.454V6z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#oq3iuu0dia)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M48.78 6H37.918c-.674 0-1.22.6-1.22 1.341 0 .74.546 1.342 1.22 1.342h5.184v27.785c0 2.436-1.803 4.42-4.018 4.42H11.906c-2.215 0-4.018-1.984-4.018-4.42 0-.741-.545-1.342-1.22-1.342-.672 0-1.219.601-1.219 1.342 0 3.916 2.897 7.102 6.457 7.102h27.178c3.56 0 6.457-3.186 6.457-7.102V8.683h3.24c.672 0 1.219-.601 1.219-1.342C50 6.601 49.453 6 48.78 6z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "pm9c0g9hpb",
    width: 32,
    height: 20,
    x: 0,
    y: 6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 6h31.708v19.974H0V6z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pm9c0g9hpb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M5.45 24.632c0 .74.546 1.342 1.22 1.342.673 0 1.219-.601 1.219-1.342V8.682h22.6c.672 0 1.219-.6 1.219-1.34 0-.742-.546-1.342-1.22-1.342H1.22C.546 6 0 6.6 0 7.341c0 .74.546 1.342 1.22 1.342h4.23v15.95z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M30.45 25.626c-.673 0-1.22.6-1.22 1.341v6.471c0 .74.547 1.341 1.22 1.341.673 0 1.22-.6 1.22-1.34v-6.472c0-.74-.547-1.341-1.22-1.341M34.832 34.779c.673 0 1.22-.601 1.22-1.342V23.372c0-.741-.547-1.342-1.22-1.342-.673 0-1.22.6-1.22 1.342v10.065c0 .74.547 1.342 1.22 1.342M40.434 33.438V16.902c0-.741-.546-1.342-1.22-1.342-.672 0-1.219.6-1.219 1.342v16.536c0 .74.547 1.342 1.22 1.342.673 0 1.22-.601 1.22-1.342z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.b27a4f6e85d49aa941ba40fba5da709d.svg";
export { ForwardRef as ReactComponent };